import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { RootState } from '@greenkub-fronts/shared/interface';

export function useLayoutLoginFeature() {
  const navigate = useNavigate();

  const { isLoggedIn, token } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    if (isLoggedIn && token) {
      navigate('/');
    }
  }, [isLoggedIn, token]);
}

export default useLayoutLoginFeature;
